import React, { useState } from 'react';
import { proyectos } from '../mock';
import { Filter } from 'lucide-react';

const Proyectos = () => {
  const [filtroActivo, setFiltroActivo] = useState('Todos');

  const categorias = ['Todos', 'Residencial', 'Comercial', 'Industrial', 'Retail'];

  const proyectosFiltrados = filtroActivo === 'Todos'
    ? proyectos
    : proyectos.filter(p => p.categoria === filtroActivo);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="hero-section py-24">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl lg:text-6xl font-bold text-white heading-font mb-6">
            Nuestros Proyectos
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Conoce algunos de los proyectos que hemos realizado con éxito para nuestros clientes
          </p>
        </div>
      </section>

      {/* Filtros */}
      <section className="py-12 bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap items-center justify-center gap-4">
            <div className="flex items-center space-x-2 text-gray-600">
              <Filter className="w-5 h-5" />
              <span className="font-semibold">Filtrar por:</span>
            </div>
            {categorias.map((categoria) => (
              <button
                key={categoria}
                onClick={() => setFiltroActivo(categoria)}
                className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
                  filtroActivo === categoria
                    ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {categoria}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Galería de Proyectos */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {proyectosFiltrados.map((proyecto) => (
              <div
                key={proyecto.id}
                className="project-card rounded-xl overflow-hidden shadow-lg group bg-white"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={proyecto.imagen}
                    alt={proyecto.nombre}
                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="project-card-content absolute inset-0 flex flex-col justify-end p-6">
                    <span className="text-yellow-400 text-sm font-semibold mb-2">
                      {proyecto.categoria}
                    </span>
                    <h3 className="text-xl font-bold mb-2">{proyecto.nombre}</h3>
                    <p className="text-sm text-gray-200">{proyecto.descripcion}</p>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between">
                    <span className="inline-block px-3 py-1 bg-blue-100 text-blue-600 rounded-full text-sm font-semibold">
                      {proyecto.categoria}
                    </span>
                    <span className="text-gray-500 text-sm">{proyecto.fecha}</span>
                  </div>
                  <h3 className="text-xl font-bold mt-4 mb-2">{proyecto.nombre}</h3>
                  <p className="text-gray-600 text-sm">{proyecto.descripcion}</p>
                </div>
              </div>
            ))}
          </div>

          {proyectosFiltrados.length === 0 && (
            <div className="text-center py-20">
              <p className="text-xl text-gray-500">No se encontraron proyectos en esta categoría</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-blue-950 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold heading-font mb-6">
            ¿Quieres un Proyecto Como Estos?
          </h2>
          <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
            Conversemos sobre tu proyecto y cómo podemos ayudarte a hacerlo realidad
          </p>
          <a href="/contacto">
            <button className="btn-primary text-lg px-8 py-4">
              Iniciar Proyecto
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Proyectos;